import MarketResult from "./MarketResult";

export default MarketResult;